import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import pl from './About.pl.json';
import en from './About.en.json';
import ar from './About.ar.json';

const About = () => {
  const { i18n } = useTranslation();
  const [content, setContent] = useState(en);

  useEffect(() => {
    switch (i18n.language) {
      case 'pl':
        setContent(pl);
        break;
      case 'ar':
        setContent(ar);
        break;
      default:
        setContent(en);
    }
  }, [i18n.language]);

  const isArabic = i18n.language === 'ar';

  return (
    <section
      className={`max-w-[1200px] mx-auto px-4 py-10 ${
        isArabic ? 'arabic-font text-right' : 'falafel-font text-left'
      }`}
      dir={isArabic ? 'rtl' : 'ltr'}
    >
      <h2 className="text-4xl font-bold mb-6">{content.title}</h2>
      {content.paragraphs.map((p, idx) => (
        <p key={idx} className="mb-4 text-lg">
          {p}
        </p>
      ))}
    </section>
  );
};

export default About;
